/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React, { useContext } from 'react'
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle, Badge } from 'reactstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import * as Icon from 'react-feather'
import { history } from '../../../history'
import Avatar from '../../../components/@vuexy/avatar/AvatarComponent'
import NotificationList from '../../../views/pages/NotificationList/components/NotificationList'
import { AuthContext } from '../../../auth/Auth'

const UserDropdown = (props: any) => {
  let context = useContext(AuthContext)
  return (
    <DropdownMenu right>
      <DropdownItem tag="a" href="#" onClick={(e) => history.push(`/editstaff?id=${context.user?.id}`)}>
        <Icon.User size={14} className="mr-50" />
        <span className="align-middle">Edit Profile</span>
      </DropdownItem>
      <DropdownItem tag="a" href="#" onClick={(e) => history.push('/Login/login')}>
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  )
}

const NavbarUser: React.FC<any> = (props) => {
  let context = useContext(AuthContext)
  const name = context.user?.name || ''
  const getAvatarContent = () => {
    return (
      name
        ?.split(' ')
        ?.map((a: string) => a.charAt(0))
        ?.join('')
        .toUpperCase() || ''
    )
  }

  return (
    <ul className="nav navbar-nav navbar-nav-user float-right">
      <UncontrolledDropdown tag="li" className="dropdown-notification nav-item">
        <DropdownToggle tag="a" className="nav-link nav-link-label">
          <Icon.Bell size={21} />
          <Badge pill color="primary" className="badge-up">
            {context.unreadNotification}
          </Badge>
        </DropdownToggle>
        <DropdownMenu tag="ul" right className="dropdown-menu-media" style={{ width: '405px' }}>
          <li className="dropdown-menu-header">
            <div className="dropdown-header mt-0">
              <h3 className="text-white">{context.unreadNotification} New</h3>
              <span className="notification-title">App Notifications</span>
            </div>
          </li>
          <PerfectScrollbar
            className="media-list overflow-hidden position-relative"
            options={{
              wheelPropagation: false,
              useBothWheelAxes: false,
              suppressScrollX: true,
            }}
          >
            <NotificationList shouldAbortFetch={false} shouldApplyCss={true}></NotificationList>
          </PerfectScrollbar>
          <li className="dropdown-menu-footer">
            <DropdownItem tag="a" className="p-1 text-center">
              <span className="align-middle">Read all notifications</span>
            </DropdownItem>
          </li>
        </DropdownMenu>
      </UncontrolledDropdown>
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle tag="a" className="nav-link dropdown-user-link">
          <div className="user-nav d-sm-flex d-none">
            <span className=" text-bold-600">{name}</span>
          </div>
          <span data-tour="user">
            <Avatar color="warning" className="mr-1" content={getAvatarContent()} />
          </span>
        </DropdownToggle>
        <UserDropdown {...props} />
      </UncontrolledDropdown>
    </ul>
  )
}
export default NavbarUser
